<!-- Discussion image start -->
<div class="card" *ngIf="discussion.image">
  <div class="card-header">
    <h5>
      <p [innerHTML]="discussion.title"></p>
    </h5>
  </div>
  <div class="card-block">
    <ngb-carousel>
      <ng-template ngbSlide>
        <img
          class="discussion-image"
          [src]="discussion.image"
          alt="discussion-image"
        />
      </ng-template>
    </ngb-carousel>
  </div>
</div>
<!-- Discussion image end -->

<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="m-l-10">
        <h5>
          <p [innerHTML]="discussion.title"></p>
        </h5>
      </div>
    </div>
    <div
      class="row"
      [hidden]="!canModifyDiscussion"
      style="display: inline-block"
    >
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-light f-right can-modify"
        [routerLink]="['/discussion-editor', discussion.slug]"
      >
        <i class="icofont icofont-pen-alt-4"></i>Edit Discussion
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-light f-right can-modify"
        [ngClass]="{ disabled: isDeleting }"
        (click)="openDiscussionDeleteConfirmation()"
      >
        <i class="icofont icofont-trash"></i>Delete Discussion
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="">
      <div class="m-b-20">
        <h6 class="sub-title m-b-15">Description</h6>
        <p
          [innerHTML]="discussion.description"
          class="discussion-description"
        ></p>
      </div>
      <div class="m-b-20">
        <h6 class="sub-title m-b-15">Body</h6>
        <div [innerHTML]="discussion.body" class="discussion-body"></div>
      </div>
    </div>

    <div class="key-buttons">
      <!-- Upvote button start -->
      <upvote-discussion-button
        [discussion]="discussion"
        (onToggle)="onToggleUpvote($event)"
        class="pull-left"
      >
      </upvote-discussion-button>
      <!-- Upvote button end-->

      <!-- Downvote button start -->
      <downvote-discussion-button
        [discussion]="discussion"
        (onToggle)="onToggleDownvote($event)"
        class="pull-left"
      >
      </downvote-discussion-button>
      <!-- Downvote button end -->

      <!-- Bookmark button start -->
      <bookmark-discussion-button
        [discussion]="discussion"
        (onToggle)="onToggleBookmark($event)"
        class="pull-left"
      >
      </bookmark-discussion-button>
      <!-- Bookmark button start-->

      <!-- Discussion-comments-button -->
      <add-comment-button
        [currentUser]="currentUser"
        [discussion]="discussion"
        [currentPanelMember]="currentPanelMember"
        class="pull-left"
      >
      </add-comment-button>
      <!-- Discussion-comments-button -->
    </div>
  </div>
</div>

<!-- Sign-in-section -->
<div class="card" *showAuthed="false">
  <div class="card-body">
    <div class="">
      <div>
        <button
          type="button"
          class="btn btn-sm btn-outline-primary login-register-button"
        >
          <a [routerLink]="['/login']">
            <i class="icofont icofont-sign-in"></i>
            Sign in
          </a>
        </button>
        or
        <button
          type="button"
          class="btn btn-sm btn-outline-primary login-register-button"
        >
          <a [routerLink]="['/register']">
            <i class="icofont icofont-page"></i>Register
          </a>
        </button>
        to add comments on this discussion.
      </div>
    </div>
  </div>
</div>

<!-- Social-share-section -->
<div class="card stop-overflow">
  <div class="card-header">
    <h5 class="card-header-text">
      <i class="icofont icofont-share-alt m-r-10"></i>Share this discussion
    </h5>
  </div>
  <div class="card-body social-share">
    <div class="j-span12 j-unit">
      <social-share-buttons [discussion]="discussion"> </social-share-buttons>
    </div>
  </div>
</div>
